import React from "react";
import { Card, Typography, Button, CircularProgress } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { makeStyles } from "@mui/styles";
import "./styles.css";
import { useSelector } from "react-redux";
import { Google, EmailSharp } from "@mui/icons-material";
import { Link, useHistory } from "react-router-dom";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../firebase";
import Locale from "../../locales";

const useStyles = makeStyles({
  headingText: {
    marginLeft: "50px",
  },
  signinCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
  },
  signInButton: {
    width: "80%",
    height: "60px",
  },
  loadingContainer: {
    display: "flex",
    gap: "10px",
  },
});

const LandingPage = ({ initialLoad = false }) => {
  const history = useHistory();

  const loading = useSelector((state) => state.authReducer.loading);
  const styles = useStyles();

  const signinWithGoogle = () => {
    const googleProvider = new GoogleAuthProvider();
    signInWithPopup(auth, googleProvider).catch(() =>
      // eslint-disable-next-line no-alert
      alert(Locale.t("something_went_wrong")),
    );
  };

  return (
    <div className="landing-page-container">
      <div className="landing-heading-container">
        <Typography variant="h2" className={styles.headingText}>
          {Locale.t("blobit")}
        </Typography>
      </div>
      <div className="signin-card-container">
        <Card elevation={6} className={styles.signinCard}>
          {(loading || initialLoad) && (
            <p className={styles.loadingContainer}>
              <CircularProgress size={20} /> Signing in Please wait...
            </p>
          )}
          <div className="signin-header">
            <Typography variant="h5">
              {Locale.t("sign_in_to_blobit")}
            </Typography>
            <Typography variant="caption">
              {Locale.t("you_can_sign_in_with_your_google_account")}
            </Typography>
          </div>

          <Button
            className={styles.signInButton}
            variant="contained"
            startIcon={<EmailSharp />}
            disabled={loading || initialLoad}
            onClick={() => history.push("/signin")}>
            {Locale.t("sign_in_with_email")}
          </Button>

          <LoadingButton
            disabled={loading || initialLoad}
            loadingPosition="start"
            startIcon={<Google />}
            size="large"
            className={styles.signInButton}
            variant="contained"
            color="primary"
            onClick={signinWithGoogle}>
            {Locale.t("sign_in_with_google")}
          </LoadingButton>

          <Link to="/privacy-policy">
            <Typography variant="caption"> Privacy policy </Typography>
          </Link>
        </Card>
      </div>
    </div>
  );
};

export default LandingPage;
